import React from 'react';
import { Sprout, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* 회사 정보 */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="p-2 bg-green-600 rounded-lg">
                <Sprout className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold text-white">WITHPLUS IFMS</span>
            </div>
            <p className="text-sm text-gray-400 mb-4">지능형 농장 관리 시스템으로 스마트 농업의 미래를 만들어갑니다.</p>
            <div className="flex gap-3">
              <a href="#" className="p-2 bg-gray-800 hover:bg-green-600 rounded-lg transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-gray-800 hover:bg-green-600 rounded-lg transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-gray-800 hover:bg-green-600 rounded-lg transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" className="p-2 bg-gray-800 hover:bg-green-600 rounded-lg transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* 제품 */}
          <div>
            <h3 className="text-white font-bold mb-4">제품</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  기능
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  가격
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  데모
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  API 문서
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  업데이트
                </a>
              </li>
            </ul>
          </div>

          {/* 지원 */}
          <div>
            <h3 className="text-white font-bold mb-4">지원</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  고객센터
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  설치 가이드
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  커뮤니티
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-green-400 transition-colors">
                  파트너
                </a>
              </li>
            </ul>
          </div>

          {/* 연락처 */}
          <div>
            <h3 className="text-white font-bold mb-4">연락처</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
                {/* <span className="text-sm">서울특별시 강남구 테헤란로 123</span> */}
                <span className="text-sm">준비중</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-green-400 flex-shrink-0" />
                {/* <span className="text-sm">1588-0000</span> */}
                <span className="text-sm">010-5550-2040</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-green-400 flex-shrink-0" />
                {/* <span className="text-sm">contact@ifms.com</span> */}
                <span className="text-sm">synchvision@gmail.com</span>
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-sm text-gray-400 mb-2">뉴스레터 구독</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="이메일 주소"
                  className="flex-1 px-3 py-2 bg-gray-800 border border-gray-700 rounded-lg focus:outline-none focus:border-green-500 text-sm"
                />
                <button className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg transition-colors">구독</button>
              </div>
            </div>
          </div>
        </div>

        {/* 하단 구분선 */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">© {currentYear} WITHPLUS IFMS. All rights reserved.</p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="hover:text-green-400 transition-colors">
                개인정보처리방침
              </a>
              <a href="#" className="hover:text-green-400 transition-colors">
                이용약관
              </a>
              <a href="#" className="hover:text-green-400 transition-colors">
                쿠키 정책
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
